import styled from 'styled-components';
import { isMobileBreakpoint } from 'ToolboxUtils/web/is-mobile-view';

export const UpcomingEventsHomeCardWrapper = styled.div`
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.1);
  background: white;
  padding-bottom: 5px;

  &:hover {
    cursor: pointer;
  }

  .line-clamp-1,
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .line-clamp-1 {
    -webkit-line-clamp: 1;
  }
  .line-clamp-2 {
    -webkit-line-clamp: 2;
  }

  .upcoming-events-home-card-image {
    width: 100%;
    position: relative;
    margin-bottom: 5px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
    }

    &:after {
      content: '';
      padding-bottom: 130%;
      display: block;
    }
  }

  .upcoming-events-home-card-title,
  .upcoming-events-home-card-city,
  .upcoming-events-home-card-date {
    padding: 0 5px;
  }

  .upcoming-events-home-card-title {
    font-size: ${props => `${18*props.theme.font.primaryFont.scaling/100}px`};
    font-weight: ${props => parseInt(props.theme.font.primaryFont.weight)+300};
    line-height: 24px;
    height: 48px;
  }

  .upcoming-events-home-card-city {
    font-size: ${props => `${14*props.theme.font.primaryFont.scaling/100}px`};
  }

  .upcoming-events-home-card-date {
    color: ${props => props.theme.color.primaryColor};
    font-size: ${props => `${14*props.theme.font.primaryFont.scaling/100}px`};
  }

  @media (max-width: ${isMobileBreakpoint}px) {
    .upcoming-events-home-card-image {
      max-height: 300px;
    }
    .upcoming-events-home-card-title {
      font-size: ${props => `${20*props.theme.font.primaryFont.scaling/100}px`};
      margin-top: 10px;
    }
  }
`;
